angular.module('unica_event.event_services')

.factory('EventDeleteService', function ($http, getBaseApiURL) {

	var eventDeleteService = {};

	eventDeleteService.delete = function (eventId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/event/delete/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return eventDeleteService;
});